import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import HomePage from "./Pages/Home/HomePage";
import LoginPage from "./Pages/Auth/LoginPage";
import config from "./config";
import VerifyAccountPage from "./Pages/Auth/VerifyAccountPage";
import { useEffect } from "react";

const theme = createTheme({
  palette: {
    primary: {
      light: "#ac1e1c",
      main: config.PRIMARY_COLOR,
      darker: "#010102",
    },
    secondary: {
      light: "#71b4b2",
      main: config.SECONDARY_COLOR,
      dark: "#a4a4a3",
    },
  },
});

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Routes>
            <Route path="/*" element={<HomePage />} />
            <Route exact path="/login" element={<LoginPage />} />
            {/* <Route
              exact
              path="/account/:accountCode/verification/:verificationCode"
              element={<VerifyAccountPage />}
            /> */}
          </Routes>
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
